import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { PageFrame } from '@platform/engine/list/header/PageFrame';
import { PageHeader } from '@platform/engine/list/header/PageHeader';
import { useModuleCrumbs } from '@platform/engine/list/header/useModuleCrumbs';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import { ErrorBanner, Spinner } from '@platform/ui';
import type { IModulePageProps } from '../IModulePageProps';
import { PartyCalendar } from './PartyCalendar';
import { usePartyCalendar } from './usePartyCalendar';

/**
 * Сторінка «Календар» модулів «Партія і група» (прототип v4 isPcal, ключ сторінки `pcal`): крихти, назва модуля над «Календар партії»,
 * «Усі події партії: …»; тіло — календар подій усіх партійних модулів простору.
 */
export function PartyCalendarPage({ ws, module }: IModulePageProps) {
  const { t } = useTranslation();
  const lang = useAppSelector(selectLang);
  const strings = useModuleStrings(module.module.key);
  const moduleName = strings.moduleName(module.module.name);
  const crumbs = useModuleCrumbs(module.module.key, moduleName);
  const data = usePartyCalendar(ws, lang);
  const head = <PageHeader eyebrow={moduleName} title={t('modBody.pcal.title')} description={t('modBody.pcal.desc')} />;
  return (
    <PageFrame crumbs={crumbs} head={head}>
      {data.error ? <ErrorBanner error={data.error} /> : data.isLoading && !data.events.length ? <Spinner /> : <PartyCalendar data={data} lang={lang} />}
    </PageFrame>
  );
}
